import React from 'react';
import PropTypes from 'prop-types';

import CheckCircle from '@material-ui/icons/CheckCircle';
import DoneOutlined from '@material-ui/icons/DoneOutlined';
import { withStyles } from '@material-ui/core/styles';

import Theme from 'LegacyWeployDesignLanguage/Theme';

import commonStyles from './styles';

const CIRCLE = 'CIRCLE';
const OUTLINED = 'OUTLINED';

const SMALL = 'SMALL';
const MEDIUM = 'MEDIUM';

const styles = () => ({
  icon: {
    ...commonStyles().icon,
    color: Theme.colors.weployAqua,
  },
  small: {
    fontSize: '14px',
  },
});

const CheckIcon = ({
  classes,
  type,
  size,
  ...rest
}) => {
  const classNames = [classes.icon];

  if (size === SMALL) {
    classNames.push(classes.small);
  }

  return (
    type === CIRCLE
      ? <CheckCircle className={classNames.join(' ')} {...rest} />
      : <DoneOutlined className={classNames.join(' ')} {...rest} />
  );
};

CheckIcon.propTypes = {
  type: PropTypes.string,
  size: PropTypes.string,
  classes: PropTypes.object.isRequired,
};

CheckIcon.defaultProps = {
  type: CIRCLE,
  size: MEDIUM,
};

CheckIcon.CIRCLE = CIRCLE;
CheckIcon.OUTLINED = OUTLINED;

CheckIcon.SMALL = SMALL;
CheckIcon.MEDIUM = MEDIUM;

export default withStyles(styles)(CheckIcon);
